export const DISPATCHES_LIST_KEY = 'DISPATCHES_LIST';
export const DISPATCHES_ONE_KEY = 'DISPATCHES_ONE_KEY';
export const DISPATCH_VERIFY_KEY = 'DISPATCH_VERIFY_KEY';
export const DISPATCH_BY_DISTRIBUTION_CENTER = 'DISPATCH_BY_DISTRIBUTION_CENTER';
